/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EntityInputDialogComponent } from '@gh/common-internal-shared';
import { createDialogRoute } from '@gh/common-shared';

import { OfficeRoleListBusinessService } from '../../resources/office-role-list-business.service';

export const officeRoleDialog = createDialogRoute({
  component: EntityInputDialogComponent,
  init: OfficeRoleListBusinessService,
});
